"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputHovered = exports.inputFocused = exports.inputReadOnly = exports.inputDisabled = exports.inputStatus = exports.baseStyles = void 0;

var _stylitas = require("@creditas/stylitas");

var _consts = require("./consts");

var baseStyles = function baseStyles(_ref) {
  var theme = _ref.theme,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '280px' : _ref$width;
  return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  border-radius: 8px;\n  cursor: text;\n  width: ", ";\n  border: ", "px solid\n    ", ";\n"])), width, _consts.DEFAULT_BORDER_SIZE, _stylitas.utilities.palette.color(theme, 'neutral05'));
};

exports.baseStyles = baseStyles;

var inputStatus = function inputStatus(_ref2) {
  var theme = _ref2.theme,
      variant = _ref2.variant;
  return variant !== 'default' && (0, _stylitas.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    border: ", "px solid\n      ", ";\n  "])), _consts.DEFAULT_BORDER_SIZE, _stylitas.utilities.palette.color(theme, variant));
};

exports.inputStatus = inputStatus;

var inputDisabled = function inputDisabled(_ref3) {
  var theme = _ref3.theme,
      disabled = _ref3.disabled;
  return disabled && (0, _stylitas.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    border: ", "px solid\n      ", ";\n  "])), _consts.DEFAULT_BORDER_SIZE, _stylitas.utilities.palette.color(theme, 'neutral04'));
};

exports.inputDisabled = inputDisabled;

var inputReadOnly = function inputReadOnly(_ref4) {
  var theme = _ref4.theme,
      readOnly = _ref4.readOnly;
  return readOnly && (0, _stylitas.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    border: ", "px solid\n      ", ";\n  "])), _consts.DEFAULT_BORDER_SIZE, _stylitas.utilities.palette.color(theme, 'neutral04'));
};

exports.inputReadOnly = inputReadOnly;

var inputFocused = function inputFocused(_ref5) {
  var theme = _ref5.theme,
      inputFocus = _ref5.inputFocus,
      variant = _ref5.variant;
  return inputFocus && (0, _stylitas.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    border: ", "px solid\n      ", ";\n  "])), _consts.FOCUSED_BORDER_SIZE, _stylitas.utilities.palette.color(theme, _consts.STYLE_VARIANTS.includes(variant) ? variant : 'secondary05'));
};

exports.inputFocused = inputFocused;

var inputHovered = function inputHovered(_ref6) {
  var theme = _ref6.theme,
      inputFocus = _ref6.inputFocus,
      inputHover = _ref6.inputHover,
      variant = _ref6.variant,
      disabled = _ref6.disabled,
      readOnly = _ref6.readOnly;
  return !inputFocus && !disabled && !readOnly && inputHover && variant === 'default' && (0, _stylitas.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    border: ", "px solid\n      ", ";\n  "])), _consts.DEFAULT_BORDER_SIZE, _stylitas.utilities.palette.color(theme, 'neutral07'));
};

exports.inputHovered = inputHovered;